import { Outlet } from "react-router-dom"

const AuthorizationPage = () => {
  return (
    <Outlet/>
  )
}

export default AuthorizationPage;
